'use strict';

const accordionContactItems = document.querySelectorAll('.accordion-topics-item');

accordionContactItems.forEach((item) => {
  const button = item.querySelector('button');
  const content = item.querySelector('.accordion-content');
  const classOpen = 'is-open';

  if (button) {
    button.addEventListener('click', () => {
      if (item.classList.contains(classOpen)) {

        content.style.height = '0px';

        content.addEventListener('transitionend', function () {
          item.classList.remove(classOpen);
        }, {
          once: true
        });

      } else {
        item.classList.add(classOpen);
        content.style.height = 'auto';

        let height = content.clientHeight + 'px';

        content.style.height = '0px';

        setTimeout(function () {
          content.style.height = height;
        }, 0);
      }

    });
  }
});
